module.exports = __webpack_public_path__ + "img/Bootcamp.26af5f9e.jpg";